import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import WarningBarMessage from './WarningBarMessage';
import {AlertSkeleton, ButtonSkeleton} from '..';
import {Alert} from '../index';
import {useGetAlerts} from '../../hooks';

const useStyles = makeStyles(theme => ({
    root: {
        listStyle: 'none',
        padding: 0,
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    }
}));

export interface AlertWarningBarsProps {
    messages: Record<string, string>;
}

const AlertWarningBars: React.FC<AlertWarningBarsProps> = ({messages}) => {
    const styles = useStyles();
    const [mounted, setMounted] = useState(false);
    const {isLoading, alerts} = useGetAlerts();

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted || !alerts.length) {
        return null;
    }

    return (
        <ul id="alerts" className={styles.root}>
            {isLoading ? (
                <AlertSkeleton AlertProps={{action: <ButtonSkeleton />}} />
            ) : (
                <>
                    {alerts.map(({msgCodes, type, ...alertItemProps}) => {
                        return (
                            <Alert
                                {...alertItemProps}
                                CollapseProps={{component: 'li'}}
                                key={`Alert-${type}`}
                                type={type}
                                message={
                                    <WarningBarMessage messages={messages} msgCodes={msgCodes} />
                                }
                            />
                        );
                    })}
                </>
            )}
        </ul>
    );
};

export default AlertWarningBars;
